import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';

const onScroll = () => {
	const addClass = (e) => {
		if (e.target.classList && !e.target.classList.contains('on-scroll')) {
			e.target.classList.add('on-scroll');
		}
	};

	const removeClass = (e) => {
		const elements = document.getElementsByClassName('on-scroll');

		for (const element of elements) {
			if (element !== e.target) {
				element.classList.remove('on-scroll');
			}
		}

		setTimeout(function() {
			if (e.target.classList?.contains('on-scroll')) {
				e.target.classList.remove('on-scroll');
			}
		}, 1000);
	};

	const throttle_addClass = throttle(addClass, 300, {
		trailing: false,
		leading:  true,
	});

	const debounce_removeClass = debounce(removeClass, 1500, {
		trailing: true,
		leading:  false,
	});

	window.addEventListener('scroll', throttle_addClass, true);
	window.addEventListener('scroll', debounce_removeClass, true);
};

export { onScroll };
